import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M400 261.92H0v.2h400z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M400 261.92H0v.2h400z",
        opacity: ".1"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M359.92 274.792h-26.496v.2h26.496z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M359.92 274.792h-26.496v.2h26.496z",
        opacity: ".06"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M264.976 276.968h-6.952v.2h6.952z"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M264.976 276.968h-6.952v.2h6.952z",
        opacity: ".06"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M332.624 267.368h-15.352v.2h15.352z"
    }, "6"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M332.624 267.368h-15.352v.2h15.352z",
        opacity: ".06"
    }, "7"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M76.5198 268.712h-34.552v.2h34.552z"
    }, "8"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M76.5198 268.712h-34.552v.2h34.552z",
        opacity: ".06"
    }, "9"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M88.712 268.712h-5.0641v.2h5.0641z"
    }, "10"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M88.712 268.712h-5.0641v.2h5.0641z",
        opacity: ".06"
    }, "11"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M180.12 272.088h-74.944v.2h74.944z"
    }, "12"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M180.12 272.088h-74.944v.2h74.944z",
        opacity: ".06"
    }, "13"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M189.6 226.24H35.1279a4.565 4.565 0 0 1-3.2249-1.341 4.567 4.567 0 0 1-1.3351-3.227V4.528A4.568 4.568 0 0 1 35.1279 0H189.6c1.211 0 2.373.4813 3.23 1.338a4.567 4.567 0 0 1 1.338 3.23v217.104a4.568 4.568 0 0 1-4.568 4.568M35.1279.16a4.368 4.368 0 0 0-4.36 4.368v217.144c0 1.157.4591 2.267 1.2765 3.086a4.367 4.367 0 0 0 3.0835 1.282H189.6a4.374 4.374 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V4.528a4.375 4.375 0 0 0-1.282-3.0863A4.376 4.376 0 0 0 189.6.16z"
    }, "14"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M189.6 226.24H35.1279a4.565 4.565 0 0 1-3.2249-1.341 4.567 4.567 0 0 1-1.3351-3.227V4.528A4.568 4.568 0 0 1 35.1279 0H189.6c1.211 0 2.373.4813 3.23 1.338a4.567 4.567 0 0 1 1.338 3.23v217.104a4.568 4.568 0 0 1-4.568 4.568M35.1279.16a4.368 4.368 0 0 0-4.36 4.368v217.144c0 1.157.4591 2.267 1.2765 3.086a4.367 4.367 0 0 0 3.0835 1.282H189.6a4.374 4.374 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V4.528a4.375 4.375 0 0 0-1.282-3.0863A4.376 4.376 0 0 0 189.6.16z",
        opacity: ".06"
    }, "15"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M362.648 226.24h-154.48a4.578 4.578 0 0 1-3.228-1.34 4.576 4.576 0 0 1-1.34-3.228V4.528a4.578 4.578 0 0 1 1.354-3.202A4.577 4.577 0 0 1 208.168 0h154.48a4.568 4.568 0 0 1 3.206 1.3294A4.566 4.566 0 0 1 367.2 4.528v217.144c0 1.209-.479 2.368-1.332 3.224a4.564 4.564 0 0 1-3.22 1.344M208.168.16a4.374 4.374 0 0 0-3.086 1.2817A4.375 4.375 0 0 0 203.8 4.528v217.144a4.372 4.372 0 0 0 1.282 3.086c.818.819 1.928 1.28 3.086 1.282h154.48a4.372 4.372 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V4.528a4.375 4.375 0 0 0-1.282-3.0863A4.374 4.374 0 0 0 362.648.16z"
    }, "16"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M362.648 226.24h-154.48a4.578 4.578 0 0 1-3.228-1.34 4.576 4.576 0 0 1-1.34-3.228V4.528a4.578 4.578 0 0 1 1.354-3.202A4.577 4.577 0 0 1 208.168 0h154.48a4.568 4.568 0 0 1 3.206 1.3294A4.566 4.566 0 0 1 367.2 4.528v217.144c0 1.209-.479 2.368-1.332 3.224a4.564 4.564 0 0 1-3.22 1.344M208.168.16a4.374 4.374 0 0 0-3.086 1.2817A4.375 4.375 0 0 0 203.8 4.528v217.144a4.372 4.372 0 0 0 1.282 3.086c.818.819 1.928 1.28 3.086 1.282h154.48a4.372 4.372 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V4.528a4.375 4.375 0 0 0-1.282-3.0863A4.374 4.374 0 0 0 362.648.16z",
        opacity: ".06"
    }, "17"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M231.752 95.2479h110.224v-72.184H231.752z"
    }, "18"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M231.752 95.2479h110.224v-72.184H231.752z",
        opacity: ".12"
    }, "19"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M228.384 95.2479H340.4v-72.184H228.384z"
    }, "20"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M228.384 95.2479H340.4v-72.184H228.384z",
        opacity: ".08"
    }, "21"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M231.752 109.408h110.224V95.24H231.752z"
    }, "22"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M231.752 109.408h110.224V95.2402H231.752z",
        opacity: ".12"
    }, "23"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M222.792 109.408h112.016V95.24H222.792z"
    }, "24"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M222.792 109.408h112.016V95.2402H222.792z",
        opacity: ".08"
    }, "25"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M335.696 90.5437V27.7756h-102.6v62.7681z"
    }, "26"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M335.696 90.5434v-62.768h-102.6v62.768z",
        opacity: ".02"
    }, "27"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m312.56 90.5356-13.104-62.76h-20.448l13.104 62.76zm20.96-4.6796c.045 0 .089-.0089.131-.0263a.35.35 0 0 0 .11-.0749.33.33 0 0 0 .072-.1118.34.34 0 0 0 .023-.131V30.84a.336.336 0 0 0-.098-.2376.337.337 0 0 0-.238-.0984.33.33 0 0 0-.13.0233.325.325 0 0 0-.182.1828.32.32 0 0 0-.024.1299v54.672a.34.34 0 0 0 .023.131.34.34 0 0 0 .073.1118c.031.032.068.0575.11.0749a.33.33 0 0 0 .13.0263"
    }, "28"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M333.52 85.856c.045 0 .089-.0089.131-.0263a.35.35 0 0 0 .11-.0749.33.33 0 0 0 .072-.1118.34.34 0 0 0 .023-.131V30.84a.336.336 0 0 0-.098-.2376.337.337 0 0 0-.238-.0984.33.33 0 0 0-.13.0233.325.325 0 0 0-.182.1828.32.32 0 0 0-.024.1299v54.672a.34.34 0 0 0 .023.131.34.34 0 0 0 .073.1118c.031.032.068.0575.11.0749a.33.33 0 0 0 .13.0263",
        opacity: ".08"
    }, "29"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m287.72 90.5356-13.104-62.76h-7.976l13.112 62.76zm-54.024.008v-62.768h-.6v62.768z"
    }, "30"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M233.696 90.5434v-62.768h-.6v62.768z",
        opacity: ".12"
    }, "31"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 34.8716h110.224l.432-5.272H227.712z",
        opacity: ".6"
    }, "32"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 34.8716h110.224l.432-5.272H227.712z",
        opacity: ".06"
    }, "33"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 43.5123h110.224l.432-5.264H227.712z",
        opacity: ".6"
    }, "34"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 43.5123h110.224l.432-5.264H227.712z",
        opacity: ".06"
    }, "35"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 52.1519h110.224l.432-5.264H227.712z",
        opacity: ".6"
    }, "36"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 52.1517h110.224l.432-5.264H227.712z",
        opacity: ".06"
    }, "37"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 60.8003h110.224l.432-5.272H227.712z",
        opacity: ".6"
    }, "38"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 60.8003h110.224l.432-5.272H227.712z",
        opacity: ".06"
    }, "39"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 69.44h110.224l.432-5.272H227.712z",
        opacity: ".6"
    }, "40"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 69.44h110.224l.432-5.272H227.712z",
        opacity: ".06"
    }, "41"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M227.28 78.0806h110.224l.432-5.272H227.712z",
        opacity: ".6"
    }, "42"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.28 78.0806h110.224l.432-5.272H227.712z",
        opacity: ".06"
    }, "43"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M326.152 209.424H303.04v4.56h23.112z"
    }, "44"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M326.152 209.424H303.04v4.56h23.112z",
        opacity: ".12"
    }, "45"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M259.448 261.92h4.264V157.064h-4.264z"
    }, "46"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M259.448 261.92h4.264V157.064h-4.264z",
        opacity: ".12"
    }, "47"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M244.664 213.984h58.368v-4.56h-58.368z"
    }, "48"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M244.664 213.984h58.368v-4.56h-58.368z",
        opacity: ".06"
    }, "49"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M326.152 234.36H303.04v4.56h23.112z"
    }, "50"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M326.152 234.36H303.04v4.56h23.112z",
        opacity: ".12"
    }, "51"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M244.664 238.912h58.368v-4.56h-58.368z"
    }, "52"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M244.664 238.912h58.368v-4.56h-58.368z",
        opacity: ".06"
    }, "53"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M326.152 159.561H303.04v4.56h23.112z"
    }, "54"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M326.152 159.561H303.04v4.56h23.112z",
        opacity: ".12"
    }, "55"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M244.664 164.112h58.368v-4.56h-58.368z"
    }, "56"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M244.664 164.112h58.368v-4.56h-58.368z",
        opacity: ".06"
    }, "57"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M326.152 184.488H303.04v4.56h23.112z"
    }, "58"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M326.152 184.488H303.04v4.56h23.112z",
        opacity: ".12"
    }, "59"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M244.664 189.048h58.368v-4.56h-58.368z"
    }, "60"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M244.664 189.048h58.368v-4.56h-58.368z",
        opacity: ".06"
    }, "61"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M317.824 261.92h4.264V157.064h-4.264z"
    }, "62"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M317.824 261.92h4.264V157.064h-4.264z",
        opacity: ".12"
    }, "63"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M298.768 261.92h4.264V157.064h-4.264z"
    }, "64"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M298.768 261.92h4.264V157.064h-4.264z",
        opacity: ".06"
    }, "65"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M244.664 261.92h4.264V157.064h-4.264z"
    }, "66"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M244.664 261.92h4.264V157.064h-4.264z",
        opacity: ".06"
    }, "67"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M52.3038 261.92h43.664v-84.712h-43.664z"
    }, "68"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M52.3038 261.92h43.664v-84.712h-43.664z",
        opacity: ".12"
    }, "69"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M63.9599 261.92h-11.664v-11.696h23.888z"
    }, "70"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M63.9599 261.92h-11.664v-11.696h23.888z",
        opacity: ".02"
    }, "71"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M171.344 261.92h43.664v-84.712h-43.664z"
    }, "72"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M171.344 261.92h43.664v-84.712h-43.664z",
        opacity: ".12"
    }, "73"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M52.3038 257.888H181.528V177.2H52.3038z"
    }, "74"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M52.3038 257.888H181.528V177.2H52.3038z",
        opacity: ".02"
    }, "75"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M169.864 261.92h11.656v-11.696h-23.88z"
    }, "76"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M169.864 261.92h11.656v-11.696h-23.88z",
        opacity: ".02"
    }, "77"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M61.344 227.464H172.48v-20.192H61.344z"
    }, "78"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M61.344 227.464H172.48v-20.192H61.344z",
        opacity: ".08"
    }, "79"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M61.344 251.968H172.48v-20.192H61.344z"
    }, "80"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M61.344 251.968H172.48v-20.192H61.344z",
        opacity: ".08"
    }, "81"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M151.36 209.433H82.4721a3.66 3.66 0 0 1-2.5908-1.074 3.663 3.663 0 0 1-1.0732-2.59v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.67 3.67 0 0 1-2.586 1.076"
    }, "82"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M151.36 209.433H82.4721a3.66 3.66 0 0 1-2.5908-1.074 3.663 3.663 0 0 1-1.0732-2.59v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.67 3.67 0 0 1-2.586 1.076",
        opacity: ".02"
    }, "83"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M61.344 202.952H172.48V182.76H61.344z"
    }, "84"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M61.344 202.952H172.48V182.76H61.344z",
        opacity: ".08"
    }, "85"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M151.36 184.92H82.4721a3.6635 3.6635 0 0 1-3.664-3.664v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.666 3.666 0 0 1-2.586 1.076"
    }, "86"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M151.36 184.92H82.4721a3.6635 3.6635 0 0 1-3.664-3.664v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.666 3.666 0 0 1-2.586 1.076",
        opacity: ".02"
    }, "87"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M151.36 233.944H82.4721a3.6635 3.6635 0 0 1-3.664-3.664v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.666 3.666 0 0 1-2.586 1.076"
    }, "88"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M151.36 233.944H82.4721a3.6635 3.6635 0 0 1-3.664-3.664v-.248h76.2079v.248c0 .97-.385 1.901-1.07 2.588a3.666 3.666 0 0 1-2.586 1.076",
        opacity: ".02"
    }, "89"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M59.256 95.2479H169.48v-72.184H59.256z"
    }, "90"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M59.256 95.2479H169.48v-72.184H59.256z",
        opacity: ".12"
    }, "91"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M55.8961 95.2479H167.912v-72.184H55.8961z"
    }, "92"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M55.8961 95.2479H167.912v-72.184H55.8961z",
        opacity: ".08"
    }, "93"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M59.256 109.408H169.48V95.24H59.256z"
    }, "94"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M59.256 109.408H169.48V95.2402H59.256z",
        opacity: ".12"
    }, "95"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M50.2882 109.408H162.304V95.24H50.2882z"
    }, "96"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M50.2877 109.408H162.304V95.2402H50.2877z",
        opacity: ".08"
    }, "97"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M163.2 90.5436v-62.768H60.6002v62.768z"
    }, "98"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M163.2 90.5434v-62.768H60.6002v62.768z",
        opacity: ".02"
    }, "99"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m140.064 90.5356-13.104-62.76h-20.448l13.104 62.76zm20.952-4.6796c.045 0 .089-.0089.131-.0263a.35.35 0 0 0 .11-.0749.33.33 0 0 0 .072-.1118.34.34 0 0 0 .023-.131V30.84a.34.34 0 0 0-.023-.1299.33.33 0 0 0-.073-.1101.326.326 0 0 0-.24-.096.335.335 0 0 0-.237.0984.337.337 0 0 0-.099.2376v54.672a.33.33 0 0 0 .024.131c.016.0417.04.0797.072.1118a.337.337 0 0 0 .24.1012"
    }, "100"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M161.016 85.856c.045 0 .089-.0089.131-.0263a.35.35 0 0 0 .11-.0749.33.33 0 0 0 .072-.1118.34.34 0 0 0 .023-.131V30.84a.34.34 0 0 0-.023-.1299.33.33 0 0 0-.073-.1101.326.326 0 0 0-.24-.096.335.335 0 0 0-.237.0984.337.337 0 0 0-.099.2376v54.672a.33.33 0 0 0 .024.131c.016.0417.04.0797.072.1118a.337.337 0 0 0 .24.1012",
        opacity: ".08"
    }, "101"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m115.224 90.5356-13.104-62.76h-7.976l13.104 62.76zm-54.0238.008v-62.768h-.6v62.768z"
    }, "102"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M61.2002 90.5434v-62.768h-.6v62.768z",
        opacity: ".12"
    }, "103"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 34.8716H165l.432-5.272H55.2079z",
        opacity: ".6"
    }, "104"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 34.8716H165l.432-5.272H55.2079z",
        opacity: ".06"
    }, "105"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 37.8482H165l.432-5.272H55.2079z",
        opacity: ".6"
    }, "106"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 37.8482H165l.432-5.272H55.2079z",
        opacity: ".06"
    }, "107"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 40.8158H165l.432-5.264H55.2079z",
        opacity: ".6"
    }, "108"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 40.8167H165l.432-5.264H55.2079z",
        opacity: ".06"
    }, "109"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 43.7925H165l.432-5.272H55.2079z",
        opacity: ".6"
    }, "110"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 43.7925H165l.432-5.272H55.2079z",
        opacity: ".06"
    }, "111"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 46.76H165l.432-5.264H55.2079z",
        opacity: ".6"
    }, "112"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 46.76H165l.432-5.264H55.2079z",
        opacity: ".06"
    }, "113"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M54.7759 49.7359H165l.432-5.272H55.2079z",
        opacity: ".6"
    }, "114"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M54.7759 49.7359H165l.432-5.272H55.2079z",
        opacity: ".06"
    }, "115"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M76.816 174.616h3.808v-42.472h-3.808z"
    }, "116"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M76.816 174.616h3.808v-42.472h-3.808z",
        opacity: ".06"
    }, "117"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M77.296 174.592h1.08V132.12h-1.08z"
    }, "118"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M77.296 174.592h1.08V132.12h-1.08z",
        opacity: ".02"
    }, "119"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M78.824 174.592h.424V132.12h-.424z"
    }, "120"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M78.824 174.592h.424V132.12h-.424z",
        opacity: ".02"
    }, "121"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M92.8242 177.208h-28.192c0-.942.3742-1.845 1.0404-2.512a3.552 3.552 0 0 1 2.5116-1.04h21.08c.9421 0 1.8455.374 2.5117 1.04a3.555 3.555 0 0 1 1.0403 2.512z"
    }, "122"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M92.8242 177.208h-28.192c0-.942.3742-1.845 1.0404-2.512a3.552 3.552 0 0 1 2.5116-1.04h21.08c.9421 0 1.8455.374 2.5117 1.04a3.555 3.555 0 0 1 1.0403 2.512z",
        opacity: ".08"
    }, "123"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M71.8721 158.512a1.1 1.1 0 0 0 .7726-.324c.2051-.205.3213-.482.3234-.772V129.6c0-.291-.1155-.57-.321-.775a1.094 1.094 0 0 0-.775-.321 1.09 1.09 0 0 0-.4219.081 1.093 1.093 0 0 0-.5979.594 1.09 1.09 0 0 0-.0842.421v27.848c.0103.286.1312.556.3371.755.206.198.4809.309.7669.309"
    }, "124"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M71.8721 158.512a1.1 1.1 0 0 0 .7726-.324c.2051-.205.3213-.482.3234-.772V129.6c0-.291-.1155-.57-.321-.775a1.094 1.094 0 0 0-.775-.321 1.09 1.09 0 0 0-.4219.081 1.093 1.093 0 0 0-.5979.594 1.09 1.09 0 0 0-.0842.421v27.848c.0103.286.1312.556.3371.755.206.198.4809.309.7669.309",
        opacity: ".08"
    }, "125"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M61.6562 142.239h34.1201l-3.9281-23.84H65.5843z"
    }, "126"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M61.6562 142.24h34.1201l-3.9281-23.84H65.5843z",
        opacity: ".15"
    }, "127"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M200 298.049c85.666 0 155.112-4.055 155.112-9.056s-69.446-9.056-155.112-9.056-155.1118 4.055-155.1118 9.056S114.334 298.049 200 298.049"
    }, "128"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M200 298.049c85.666 0 155.112-4.055 155.112-9.056s-69.446-9.056-155.112-9.056-155.1118 4.055-155.1118 9.056S114.334 298.049 200 298.049",
        opacity: ".06"
    }, "129"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m83.295 117.886-.7979.058 1.0627 14.754.7979-.058zm1.605 22.371-.7979.057.4 5.554.7979-.058zm185.268 67.87H98.8399a7.716 7.716 0 0 1-5.1284-2.075 7.72 7.72 0 0 1-2.4236-4.973l-8.416-116.904a6.4805 6.4805 0 0 1 3.9022-6.5161 6.48 6.48 0 0 1 2.6338-.5239H260.736a7.72 7.72 0 0 1 5.126 2.0719 7.723 7.723 0 0 1 2.426 4.9681l8.416 116.904c.078.902-.033 1.81-.327 2.667a6.49 6.49 0 0 1-1.38 2.305 6.47 6.47 0 0 1-2.195 1.549 6.48 6.48 0 0 1-2.634.527"
    }, "130"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M270.824 208.127H99.4962a7.716 7.716 0 0 1-5.1285-2.075 7.72 7.72 0 0 1-2.4235-4.973l-8.416-116.904a6.48 6.48 0 0 1 1.7068-4.9694 6.48 6.48 0 0 1 4.8292-2.0706H261.392a7.72 7.72 0 0 1 5.126 2.0719 7.718 7.718 0 0 1 2.426 4.9681l8.416 116.904a6.48 6.48 0 0 1-.324 2.668 6.5 6.5 0 0 1-1.379 2.307 6.5 6.5 0 0 1-2.197 1.549c-.832.357-1.73.535-2.636.524"
    }, "131"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M270.824 208.127H99.4962a7.716 7.716 0 0 1-5.1285-2.075 7.72 7.72 0 0 1-2.4235-4.973l-8.416-116.904a6.48 6.48 0 0 1 1.7068-4.9694 6.48 6.48 0 0 1 4.8292-2.0706H261.392a7.72 7.72 0 0 1 5.126 2.0719 7.718 7.718 0 0 1 2.426 4.9681l8.416 116.904a6.48 6.48 0 0 1-.324 2.668 6.5 6.5 0 0 1-1.379 2.307 6.5 6.5 0 0 1-2.197 1.549c-.832.357-1.73.535-2.636.524",
        opacity: ".5"
    }, "132"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M261.648 80.6548H89.7439c-4.376.36-3.48 7.024.936 7.024H262.296c4.424 0 4.36-6.664-.072-7.024z"
    }, "133"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M94.7842 84.1751a1.48 1.48 0 0 1-.3967 1.1339 1.48 1.48 0 0 1-1.1073.4661 1.76 1.76 0 0 1-1.728-1.6 1.48 1.48 0 0 1 1.496-1.6 1.76 1.76 0 0 1 1.736 1.6"
    }, "134"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M94.7842 84.1751a1.48 1.48 0 0 1-.3967 1.1339 1.48 1.48 0 0 1-1.1073.4661 1.76 1.76 0 0 1-1.728-1.6 1.48 1.48 0 0 1 1.496-1.6 1.76 1.76 0 0 1 1.736 1.6",
        opacity: ".02"
    }, "135"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M100.28 84.1751c.017.2062-.009.4137-.078.609a1.478 1.478 0 0 1-.8226.8754 1.48 1.48 0 0 1-.6031.1156 1.76 1.76 0 0 1-1.728-1.6 1.48 1.48 0 0 1 1.496-1.6 1.76 1.76 0 0 1 1.1761.4657c.3206.2957.5206.6999.5596 1.1343"
    }, "136"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M100.28 84.1751c.017.2062-.009.4137-.078.609a1.478 1.478 0 0 1-.8226.8754 1.48 1.48 0 0 1-.6031.1156 1.76 1.76 0 0 1-1.728-1.6 1.48 1.48 0 0 1 1.496-1.6 1.76 1.76 0 0 1 1.1761.4657c.3206.2957.5206.6999.5596 1.1343",
        opacity: ".02"
    }, "137"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M105.768 84.1752a1.474 1.474 0 0 1-.394 1.131 1.49 1.49 0 0 1-.501.351c-.19.0807-.395.121-.601.118a1.754 1.754 0 0 1-1.173-.4663 1.755 1.755 0 0 1-.555-1.1337 1.48 1.48 0 0 1 .075-.6084c.067-.1953.175-.3743.316-.5252s.313-.2704.503-.3508c.19-.0803.396-.1197.602-.1156.435.0062.852.173 1.171.4685.319.2954.518.6985.557 1.1315"
    }, "138"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M105.768 84.1752a1.474 1.474 0 0 1-.394 1.131 1.49 1.49 0 0 1-.501.351c-.19.0807-.395.121-.601.118a1.754 1.754 0 0 1-1.173-.4663 1.755 1.755 0 0 1-.555-1.1337 1.48 1.48 0 0 1 .075-.6084c.067-.1953.175-.3743.316-.5252s.313-.2704.503-.3508c.19-.0803.396-.1197.602-.1156.435.0062.852.173 1.171.4685.319.2954.518.6985.557 1.1315",
        opacity: ".02"
    }, "139"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M266.28 196.463H102.4a2.794 2.794 0 0 1-1.861-.753 2.79 2.79 0 0 1-.875-1.807l-6.92-96.1361a2.336 2.336 0 0 1 1.4331-2.3758 2.34 2.34 0 0 1 .9669-.1762h163.92a2.784 2.784 0 0 1 1.861.7479c.505.4718.817 1.1149.875 1.8041l6.928 96.1361a2.356 2.356 0 0 1-.643 1.836c-.232.242-.513.432-.824.557s-.646.182-.981.167"
    }, "140"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m197.224 159.839-2.672-37.056-8.08-4.864h-22.248l3.024 41.92z"
    }, "141"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M197.224 160.223h-29.976a.387.387 0 0 1-.269-.101.383.383 0 0 1-.123-.259l-3.016-41.92a.372.372 0 0 1 .104-.288.39.39 0 0 1 .126-.093.39.39 0 0 1 .154-.035h22.248c.07.003.139.022.2.056l8.08 4.864c.054.031.1.075.134.128.033.053.053.114.058.176l2.656 37.056a.38.38 0 0 1-.019.16.37.37 0 0 1-.085.136.37.37 0 0 1-.124.088.36.36 0 0 1-.148.032m-29.6-.8H196.8l-2.624-36.44-7.776-4.68h-21.76z"
    }, "142"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m194.552 122.783-8.08-4.864 2.968 6.448z"
    }, "143"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "m194.552 122.783-8.08-4.864 2.968 6.448z",
        opacity: ".1"
    }, "144"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M189.44 124.751a.39.39 0 0 1-.208-.061.4.4 0 0 1-.144-.163l-2.968-6.448a.403.403 0 0 1-.029-.242.4.4 0 0 1 .117-.214.404.404 0 0 1 .226-.094c.083-.008.166.011.238.054l8.08 4.864c.065.039.118.096.152.164s.048.144.04.22a.39.39 0 0 1-.089.2.4.4 0 0 1-.183.12l-5.12 1.6zm-2.088-5.856 2.296 5 4-1.224zM176.8 136.799a1.604 1.604 0 0 1-.436 1.189c-.15.158-.331.284-.531.37-.2.085-.415.13-.633.129a1.848 1.848 0 0 1-1.808-1.688 1.545 1.545 0 0 1 .078-.65c.071-.208.187-.399.338-.56.152-.16.336-.287.54-.37.204-.084.424-.124.644-.116.457.01.895.189 1.229.502.333.313.54.738.579 1.194m10.96 0a1.551 1.551 0 0 1-.958 1.574c-.203.083-.422.122-.642.114a1.854 1.854 0 0 1-1.231-.496 1.86 1.86 0 0 1-.585-1.192c-.013-.218.019-.436.093-.641.075-.206.191-.394.34-.553.15-.158.331-.285.532-.371.201-.087.417-.131.635-.131.46.007.9.184 1.236.498.336.313.542.741.58 1.198m3.104 10.993a.396.396 0 0 1-.261-.106.394.394 0 0 1-.123-.254c-.2-2.728-4.472-4.944-9.52-4.944-3.352 0-6.36 1-7.848 2.6a2.99 2.99 0 0 0-.912 2.288.41.41 0 0 1-.019.155.42.42 0 0 1-.078.136.406.406 0 0 1-.275.137.403.403 0 0 1-.291-.098.402.402 0 0 1-.137-.274c-.024-.531.064-1.06.257-1.555.193-.494.487-.943.863-1.317 1.6-1.752 4.856-2.848 8.416-2.848 5.544 0 10.064 2.488 10.288 5.664.004.05-.003.101-.02.149a.36.36 0 0 1-.075.129.38.38 0 0 1-.119.091.37.37 0 0 1-.146.039zm-20.328-14.417a.41.41 0 0 1-.264-.104.397.397 0 0 1-.113-.276c0-.104.041-.203.113-.276l1.704-1.832c.073-.071.171-.11.272-.11.102 0 .199.039.272.11.036.036.065.078.084.125.019.046.029.096.029.147 0 .05-.01.1-.029.147a.38.38 0 0 1-.084.125l-1.704 1.832a.38.38 0 0 1-.128.084c-.048.02-.1.029-.152.028m19.528 0a.442.442 0 0 1-.264-.104l-1.96-1.832a.39.39 0 0 1-.086-.126.37.37 0 0 1-.031-.15c0-.052.01-.103.031-.15a.39.39 0 0 1 .086-.126c.073-.071.171-.11.272-.11.102 0 .199.039.272.11l1.96 1.832a.382.382 0 0 1 .113.272c0 .05-.01.1-.029.147a.39.39 0 0 1-.084.125.416.416 0 0 1-.28.112m-28.256 34.744h1.808l2.608 3.472-.248-3.472h1.824l.448 6.272H166.4l-2.592-3.448.248 3.448h-1.824zm7.256 3.136c-.062-.426-.032-.86.086-1.274.119-.413.324-.797.602-1.126.304-.299.668-.53 1.068-.677a3 3 0 0 1 1.252-.179c.902-.049 1.787.252 2.472.84.628.625.991 1.467 1.016 2.352.066.611-.016 1.228-.24 1.8-.207.461-.554.844-.992 1.096-.525.282-1.116.417-1.712.392-.612.02-1.221-.095-1.784-.336a2.89 2.89 0 0 1-1.2-1.072 3.73 3.73 0 0 1-.568-1.816m1.944 0c-.008.491.15.97.448 1.36.125.138.279.247.45.318.171.072.356.106.542.098.178.013.355-.018.518-.089s.307-.18.418-.319c.23-.437.306-.938.216-1.424.004-.47-.155-.928-.448-1.296a1.3 1.3 0 0 0-.456-.311 1.3 1.3 0 0 0-.544-.097 1.12 1.12 0 0 0-.506.099c-.158.072-.297.181-.406.317-.234.413-.316.894-.232 1.36zm8.312-3.135h2.88c.475-.015.948.064 1.392.232.352.147.664.374.912.664.252.293.445.633.568 1 .13.394.211.802.24 1.216a4.05 4.05 0 0 1-.12 1.56c-.11.351-.305.67-.568.928-.219.232-.495.403-.8.496a4.47 4.47 0 0 1-1.144.176h-2.872zm2.04 1.424.248 3.424h.472c.292.019.585-.028.856-.136a.8.8 0 0 0 .368-.472c.092-.355.114-.725.064-1.088.016-.488-.134-.967-.424-1.36a1.43 1.43 0 0 0-.513-.3c-.19-.063-.391-.087-.591-.068zm8.6 3.807h-2.2l-.232 1.04h-1.976l1.904-6.272h2.144l2.808 6.272h-2.032zm-.504-1.352-.848-2.256-.528 2.256zm2.04-3.88h5.888l.112 1.552h-1.976l.336 4.72h-1.936l-.336-4.72h-1.976zm10.4 5.232h-2.2l-.232 1.04h-1.976l1.904-6.272h2.112l2.8 6.272h-2.024zm-.504-1.352-.856-2.256-.536 2.256z"
    }, "145"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "M282.952 94.4634c.712-.36 1.6-.8 2.352-1.256s1.6-.896 2.4-1.376c1.56-.968 3.144-1.92 4.64-2.976a61.6 61.6 0 0 0 8.416-6.928c.328-.304.616-.64.928-.968l.456-.488.224-.24.112-.128c-.112.216 0 .152 0-.056.07-.2857.11-.5779.12-.872a24.57 24.57 0 0 0-.584-5.056c-.712-3.584-1.792-7.28-2.856-10.896l3.104-1.36a65.1 65.1 0 0 1 4.888 10.88 25.37 25.37 0 0 1 1.376 6.312 9.63 9.63 0 0 1-.064 2.008 6.176 6.176 0 0 1-.976 2.632l-.136.184-.104.128-.12.152-.248.304-.496.6c-.328.392-.648.8-1 1.176a57.5 57.5 0 0 1-9.104 8.16c-1.6 1.184-3.296 2.32-5.032 3.352-.856.52-1.728 1.016-2.616 1.504s-1.752.9356-2.776 1.4156z"
    }, "146"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M275.832 282.544a8.24 8.24 0 0 0 1.776-.24.177.177 0 0 0 .12-.128.17.17 0 0 0-.013-.09.16.16 0 0 0-.059-.07c-.232-.152-2.264-1.464-3.048-1.112a.537.537 0 0 0-.216.182.54.54 0 0 0-.096.266.91.91 0 0 0 .023.454c.046.147.129.28.241.386.368.267.82.392 1.272.352m1.32-.464c-1.16.232-2.04.192-2.4-.12a.621.621 0 0 1-.16-.568.24.24 0 0 1 .041-.119.24.24 0 0 1 .095-.081c.424-.184 1.6.408 2.424.888"
    }, "147"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M277.6 282.303h.08a.19.19 0 0 0 .057-.058.17.17 0 0 0 .023-.078c0-.088 0-2.016-.736-2.656a.8.8 0 0 0-.311-.186.79.79 0 0 0-.361-.03.5504.5504 0 0 0-.536.44c-.152.8 1.064 2.2 1.704 2.568a.155.155 0 0 0 .08 0m-1.144-2.712c.13 0 .255.048.352.136.422.622.64 1.36.624 2.112-.64-.512-1.4-1.6-1.304-2.056 0-.072.056-.168.256-.192z"
    }, "148"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "M276.976 74.4552c-.8 4-2.4 12 .36 14.68 0 0-1.088 4-8.472 4-8.128 0-3.88-4-3.88-4 4.432-1.056 4.312-4.344 3.544-7.44z"
    }, "149"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M263.424 90.7349c-1.272.176-.184-3.128.328-3.472 1.2-.8 16.688-1.912 16.584 0-.064.8-.448 2.4-1.12 2.928s-4.656-1.12-15.792.544"
    }, "150"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M265.952 89.5992c-1.016.344-.92-2.984-.576-3.384.8-.928 13.336-4.144 13.704-2.328.144.8.216 2.4-.216 2.968s-4.112-.368-12.912 2.744m-4.664-22.3113a.32.32 0 0 1-.264-.12 2.54 2.54 0 0 0-.919-.7388 2.54 2.54 0 0 0-1.153-.2452.31.31 0 0 1-.124-.0085.3.3 0 0 1-.111-.0566.31.31 0 0 1-.081-.0956.31.31 0 0 1-.036-.1193.3203.3203 0 0 1 .28-.344 3.126 3.126 0 0 1 1.464.281c.459.2104.859.5284 1.168.927a.316.316 0 0 1 .072.2322.32.32 0 0 1-.112.2158.4.4 0 0 1-.184.072"
    }, "151"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FF5652",
        d: "M259.736 71.1992a14.3 14.3 0 0 1-1.6 3.624 2.321 2.321 0 0 0 1.952.168z"
    }, "152"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M260.128 70.2313c.056.536-.192 1-.544 1.032s-.68-.368-.728-.912.192-1 .536-1.032.68.368.736.912"
    }, "153"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "m259.552 69.3352-1.328-.248s.76.944 1.328.248"
    }, "154"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "M285.36 282.152h-6.704l.528-15.52h6.704z"
    }, "155"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M278.128 281.376h7.528c.13-.004.256.041.355.125s.163.202.181.331l.856 5.952c.017.15.002.303-.044.447-.047.144-.123.277-.224.389-.102.113-.226.203-.364.264-.139.061-.289.093-.44.092-2.624-.04-3.888-.2-7.2-.2-2.04 0-5.016.216-7.824.216s-2.968-2.784-1.792-3.032c5.248-1.136 6.08-2.688 7.848-4.176a1.765 1.765 0 0 1 1.12-.408"
    }, "156"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M285.888 266.631h-6.704l-.272 8h6.704z",
        opacity: ".2"
    }, "157"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "M258.696 98.3991a130 130 0 0 1-12.04-5.4 73 73 0 0 1-11.52-7.016 27.4 27.4 0 0 1-2.736-2.456c-.224-.24-.448-.464-.664-.744a8.9 8.9 0 0 1-.704-.904 6.324 6.324 0 0 1-1.072-2.888 6.58 6.58 0 0 1 .392-2.896 8.5 8.5 0 0 1 1.128-2.08 14.5 14.5 0 0 1 2.712-2.816 33.63 33.63 0 0 1 5.84-3.736c.992-.528 2-1 3.024-1.44s2.032-.856 3.128-1.232l1.416 3.08c-3.488 2.2-7.104 4.624-9.76 7.328a11.1 11.1 0 0 0-1.56 1.992c-.384.632-.376 1.104-.312 1.064s0 0 .112.08l.32.344c.12.144.288.288.44.44.678.6237 1.397 1.201 2.152 1.728a50.3 50.3 0 0 0 5.152 3.2c1.8 1.008 3.656 1.96 5.544 2.872 3.776 1.808 7.68 3.544 11.512 5.128z"
    }, "158"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "m249.6 65.7196 1.104-2.4-5.056-1.72s-1.6 4.728.296 6.904a4.84 4.84 0 0 0 2.179-.9304 4.834 4.834 0 0 0 1.477-1.8536"
    }, "159"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "m250.68 58.1271-4.024-1.168-1.008 4.608 5.032 1.752zm52 5.4242.584-5.6-5.184 1.248s-.08 5.264 2.664 6.096zm-1.912-9.5443-3.384 1.576.696 3.576 5.184-1.224zm-22.736 12.5927c.248 6.648.488 9.456-2.512 13.176-4.52 5.6-12.736 4.44-14.96-2-2-5.792-2.064-15.688 4.144-18.952a9.07 9.07 0 0 1 4.438-1.0601 9.08 9.08 0 0 1 4.393 1.2344 9.072 9.072 0 0 1 4.497 7.6017"
    }, "160"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M275.136 79.7673c6.528-2.824 10.816-8.8 9.008-18.064-1.736-8.888-7.736-9.768-10.216-7.928s-8.664-.904-12.376 2.216c-6.4 5.416-.352 11.2 2.816 14.696 1.888 3.888 4.368 11.84 10.768 9.08"
    }, "161"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M272.424 60.1111a6.63 6.63 0 0 0 3.101 2.2035 6.633 6.633 0 0 0 3.802.1368 6.633 6.633 0 0 0 3.251-1.9747 6.625 6.625 0 0 0 1.631-3.4366 6.63 6.63 0 0 0-.525-3.7677 6.634 6.634 0 0 0-2.509-2.8592 6.634 6.634 0 0 0-3.668-1.0098 6.63 6.63 0 0 0-3.619 1.1717 6.82 6.82 0 0 0-2.706 4.4649 6.82 6.82 0 0 0 1.242 5.0711"
    }, "162"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M274.12 54.3994c-.936-5.36 4.128-9.488 10.912-7.496s3.2 8 1.8 12.8 2.264 9.376 3.784 5.72-1.04-4.8-1.04-4.8 7.2 1.864.512 9.984-12.744-.848-11.104-6.136c1.328-4.248-3.976-5.008-4.864-10.072m-6.776 2.0239c-3.096-1.6-8.336-2.92-11.32 2.104-1.408 2.4-.864 5.6-.864 5.6l9.112.6z"
    }, "163"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M254.088 62.5431a.204.204 0 0 1-.139-.0692.21.21 0 0 1-.053-.1468c0-.136.232-3.352 2.176-5.368 4.696-4.88 10.2-.8 11.768.52a.202.202 0 0 1 .055.1317.2.2 0 0 1-.047.1346.201.201 0 0 1-.264.0377c-1.512-1.296-6.776-5.176-11.2-.552-1.84 1.912-2.064 5.088-2.064 5.12a.2.2 0 0 1-.02.0822.19.19 0 0 1-.052.0665.2.2 0 0 1-.075.0389.2.2 0 0 1-.085.0044"
    }, "164"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "M265.48 70.3994a5.513 5.513 0 0 1-1.32 3.424c-1.104 1.296-2.4.656-2.664-.8-.264-1.288 0-3.52 1.392-4.296s2.608.216 2.592 1.672"
    }, "165"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M264.04 131.295s.432 46.52 4.464 72.44c3.264 20.936 9.288 69.352 9.288 69.352h9.144s.888-46.744-.8-67.448c-4.184-52.4 6.624-62.2-2.096-74.344z"
    }, "166"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M264.04 131.295s.432 46.52 4.464 72.44c3.264 20.936 9.288 69.352 9.288 69.352h9.144s.888-46.744-.8-67.448c-4.184-52.4 6.624-62.2-2.096-74.344z",
        opacity: ".1"
    }, "167"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M268.848 152.399c3.2 14.04.648 36.152-1.104 45.888-1.856-14.784-2.792-33.944-3.256-48 1.656-2.672 3.224-2.848 4.36 2.112",
        opacity: ".3"
    }, "168"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M276.544 273.263h11.64l.608-4.08-12.312-.416zM279.864 92c1.096-2.176 6.984-3.544 10.2-3.536l2.4 10.688s-6.4 9.512-9.072 8.504c-3.144-1.16-5.872-10.96-3.528-15.656"
    }, "169"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M279.864 92c1.096-2.176 6.984-3.544 10.2-3.536l2.4 10.688s-6.4 9.512-9.072 8.504c-3.144-1.16-5.872-10.96-3.528-15.656",
        opacity: ".4"
    }, "170"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M273.08 270.648a.154.154 0 0 0 0-.152.157.157 0 0 0-.07-.072.15.15 0 0 0-.098-.016c-.336.056-3.296.52-3.696 1.368a.514.514 0 0 0-.065.252c0 .088.022.174.065.252.069.126.167.234.287.313.12.08.258.129.401.143.968.096 2.4-1.248 3.12-2.064zm-3.552 1.232c.272-.448 1.808-.864 2.976-1.08-1.056 1.072-1.984 1.672-2.528 1.6a.58.58 0 0 1-.263-.096.57.57 0 0 1-.185-.208.2.2 0 0 1-.027-.1c0-.036.009-.07.027-.1 0 0-.008-.008 0-.016"
    }, "171"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M273.08 270.647a.155.155 0 0 0 .021-.076.16.16 0 0 0-.021-.076c-.048-.056-1.232-1.424-2.328-1.496-.158-.013-.317.007-.467.057-.15.051-.288.133-.405.239-.328.296-.296.552-.216.712.344.688 2.472.928 3.328.744a.13.13 0 0 0 .057-.041.134.134 0 0 0 .031-.063m-3.128-1.008a.65.65 0 0 1 .128-.144.81.81 0 0 1 .293-.177c.109-.037.224-.05.339-.039.744.184 1.413.595 1.912 1.176-.952.08-2.488-.208-2.696-.624a.196.196 0 0 1-.014-.099.196.196 0 0 1 .038-.093"
    }, "172"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB573",
        d: "m280.064 267.807-6.128 2.728-2.728-5.688-3.568-7.44-.424-.864 6.128-2.728.472.976 3.456 7.208z"
    }, "173"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "m277.272 262-6.064 2.848-3.568-7.44 6.176-2.616z",
        opacity: ".2"
    }, "174"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M256.856 131.295s-19.576 48.704-14.272 71.584c4.8 20.712 26 59.936 26 59.936l8.216-4.112s-13.112-47.352-14.528-57.64c-2.768-20 15.016-48.264 15.016-69.768z"
    }, "175"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M256.856 131.295s-19.576 48.704-14.272 71.584c4.8 20.712 26 59.936 26 59.936l8.216-4.112s-13.112-47.352-14.528-57.64c-2.768-20 15.016-48.264 15.016-69.768z",
        opacity: ".1"
    }, "176"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "m272.848 269.679 6.08-4.424c.103-.08.231-.12.361-.111s.252.066.343.159l4.2 4.312c.102.113.179.245.226.39.047.144.063.297.047.448s-.063.297-.139.428-.179.245-.302.334c-2.152 1.504-3.264 2.128-5.936 4.072-1.648 1.2-4.928 3.848-7.2 5.504s-4-.504-3.2-1.392c3.584-4 4.336-6.48 4.896-8.728.087-.393.307-.743.624-.992"
    }, "177"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m268.056 264.551 10.584-4.84-1.352-4.312-11.336 5.168zm-6.008-173.0642c-.872-2.272-8.52-4.8-12.36-5.6L248 98.4628s6.272 9.0082 9.016 8.2642c3.248-.88 6.92-10.3682 5.032-15.2402"
    }, "178"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M262.048 91.4868c-.872-2.272-8.52-4.8-12.36-5.6L248 98.4628s6.272 9.0082 9.016 8.2642c3.248-.88 6.92-10.3682 5.032-15.2402",
        opacity: ".4"
    }, "179"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M253.656 90.8556s-3.2 1.12 3.2 40.4404h27.2c-.456-11.072-.472-17.904 4.8-40.6404a80.2 80.2 0 0 0-11.56-1.52 85.9 85.9 0 0 0-12.352 0c-5.272.464-11.288 1.72-11.288 1.72"
    }, "180"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M253.656 90.8556s-3.2 1.12 3.2 40.4404h27.2c-.456-11.072-.472-17.904 4.8-40.6404a80.2 80.2 0 0 0-11.56-1.52 85.9 85.9 0 0 0-12.352 0c-5.272.464-11.288 1.72-11.288 1.72",
        opacity: ".4"
    }, "181"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m284.48 129.703 1.224 2.4c.096.192-.128.384-.44.384H256.72c-.248 0-.448-.12-.464-.28l-.248-2.4c0-.168.2-.312.464-.312H284a.49.49 0 0 1 .48.208"
    }, "182"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m284.48 129.703 1.224 2.4c.096.192-.128.384-.44.384H256.72c-.248 0-.448-.12-.464-.28l-.248-2.4c0-.168.2-.312.464-.312H284a.49.49 0 0 1 .48.208",
        opacity: ".3"
    }, "183"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M280.8 132.8h.736c.152 0 .264-.08.248-.168l-.344-3.2c0-.096-.136-.168-.28-.168h-.744c-.144 0-.256.072-.248.168l.344 3.2c-.008.072.12.168.288.168m-17.912 0h.736c.144 0 .256-.08.248-.168l-.344-3.2c0-.096-.136-.168-.288-.168h-.736c-.152 0-.256.072-.248.168l.344 3.2c.008.072.136.168.288.168"
    }, "184")
], "NoData", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 400 300"
});
